import axios from 'axios';
import dayjs from 'dayjs';


axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    const userinfo = JSON.parse(sessionStorage.getItem('userInfo'));
    if (token && userinfo) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(
  response => response,
  error => {
    // if (error.response?.status === 401 || error.response?.status === 403) {
    //   alert("登入逾期，請重新登入");
    //   localStorage.removeItem('token');
    //   sessionStorage.removeItem('userInfo');
    //   window.location.href = '/admin/login';
    // }

    if (error.response?.status >= 500) {
      const now = dayjs();
      alert(now.format('YYYY-MM-DD HH:mm:ss')+' 系統忙線中，請稍後再試');
      console.log('錯誤時間',now.format('YYYY-MM-DD HH:mm:ss'));
      console.log('錯誤訊息',error.response?.data?.message);
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export default axios;